import { render, staticRenderFns } from "./AcademyTabVideos.vue?vue&type=template&id=b2fe1676&scoped=true&"
import script from "./AcademyTabVideos.vue?vue&type=script&lang=js&"
export * from "./AcademyTabVideos.vue?vue&type=script&lang=js&"
import style0 from "./AcademyTabVideos.vue?vue&type=style&index=0&id=b2fe1676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fe1676",
  null
  
)

export default component.exports